module.exports = __webpack_public_path__ + "static/media/aws-eb-create-autoscalable-instance.7deffb1b.md";